import { render } from "./VocabularyReview.vue?vue&type=template&id=60f61400"
import script from "./VocabularyReview.vue?vue&type=script&lang=js"
export * from "./VocabularyReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__